var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback } from 'react';
import { WidgetType } from '@common/api';
import { useTagContext } from '@data/tag/tagContext';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { useUpdateWidget, useWidgets } from '@data/widgets/widgetActions';
import { PivotZone, DraggableType, DroppableType } from './types';
export function usePivotWidgetToEmptyHandler() {
    var _a;
    var widgets = (_a = useWidgets().data) !== null && _a !== void 0 ? _a : [];
    var tagData = useTagContext().tagData;
    var updateWidgetMutation = useUpdateWidget();
    return useCallback(function (sourceInfo, targetInfo, draggableInfo) {
        // source, target and draggable checks
        if (sourceInfo.type !== DroppableType.PivotWidget ||
            targetInfo.type !== DroppableType.Empty ||
            draggableInfo.type !== DraggableType.Tag) {
            return { status: 'error' };
        }
        // find tag and widget
        var tag = tagData.tagById[draggableInfo.tagId];
        if (tag === undefined) {
            return { status: 'error', message: 'Tag not found' };
        }
        var widget = widgets.find(function (w) { return w.id === sourceInfo.widgetId; });
        if (widget === undefined) {
            return { status: 'error', message: 'Widget not found' };
        }
        var widgetConfig = parseWidgetConfig(widget.config, WidgetType.PIVOT);
        // update widget by area
        var widgetZone = sourceInfo.zone;
        if (widgetZone === PivotZone.Filter) {
            // remove tag from filter field
            if (widgetConfig.filters.includes(tag.id)) {
                widgetConfig.filters = widgetConfig.filters.filter(function (tagId) { return tagId !== tag.id; });
                updateWidgetMutation.mutate(__assign(__assign({}, widget), { config: JSON.stringify(widgetConfig) }));
            }
            return { status: 'success' };
        }
        else if (widgetZone === PivotZone.Column || widgetZone === PivotZone.Row) {
            // remove tag from column or row field
            var fieldName = widgetZone === PivotZone.Column ? 'columns' : 'rows';
            var fieldIndex = widgetZone === PivotZone.Column ? sourceInfo.columnIndex : sourceInfo.rowIndex;
            var field = widgetConfig[fieldName][fieldIndex];
            if (field.includes(tag.id)) {
                widgetConfig[fieldName][fieldIndex] = field.filter(function (tagId) { return tagId !== tag.id; });
                updateWidgetMutation.mutate(__assign(__assign({}, widget), { config: JSON.stringify(widgetConfig) }));
            }
            return { status: 'success' };
        }
        else if (widgetZone === PivotZone.Variable) {
            // remove tag from variable field
            var field = widgetConfig.variables[sourceInfo.rowIndex][sourceInfo.columnIndex];
            if (field.includes(tag.id)) {
                widgetConfig.variables[sourceInfo.rowIndex][sourceInfo.columnIndex] = field.filter(function (tagId) { return tagId !== tag.id; });
                updateWidgetMutation.mutate(__assign(__assign({}, widget), { config: JSON.stringify(widgetConfig) }));
            }
            return { status: 'success' };
        }
        return { status: 'error', message: 'Unknown zone in data editor' };
    }, [widgets, tagData, updateWidgetMutation]);
}
export function usePivotWidgetToDataEditorWidgetHandler() {
    return useCallback(function (sourceInfo, targetInfo, draggableInfo, combineDraggableInfo, targetIndex) {
        // WIP
        return { status: 'error', message: 'Not implemented yet' };
    }, []);
}
